export const TooltipPlacement = {
  Right: "right",
  Left: "left",
  Top: "top",
  Bottom: "bottom",
};
